<template>
    <div>
      <!-- modal -->
      <b-modal
        id="clientVisitFormModal" centered size="lg" no-close-on-backdrop ref="clientVisitFormModal" :title=" $t('clientVisit.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
        <b-row>
          <b-col class="col-lg-6">
            <b-form-group>
              <label for="client-visit-date-input">{{ $t('clientVisit.date') }}</label>
              <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
            </b-form-group>
          </b-col>
          <b-col class="col-lg-6">
            <b-form>
              <label for="client-visit-meeting-purpose-input">{{ $t('clientVisit.meeting_purpose') }}</label>
              <b-form-group>
                  <b-form-select size="sm" v-model="meetingPurposeSelect" value-field="id" text-field="name" :options="meetingPurposeOption" />
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-6">
            <label for="client-visit-interviewer-input">{{ $t('clientVisit.employee') }}</label>
            <b-form-group>
              <b-form-select size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
            </b-form-group>
          </b-col>
          <b-col class="col-lg-6">
              <label for="client-visit-interviewing-officer-input">{{ $t('clientVisit.client_responsible') }}</label>
              <b-form-group>
                <b-form-select size="sm" v-model="clientResponsibleSelect" value-field="id" text-field="name" :options="clientResponsibleOption" />
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-12">
            <label for="client-visit-meeting-summary-input">{{ $t('clientVisit.summary') }}</label>
            <b-form-group>
               <validation-provider #default="{ errors }" :name=" $t('clientVisit.summary')" rules="required">
              <b-form-textarea size="sm" id="client-visit-meeting-summary-input" :placeholder="$t('clientVisit.summary')" v-model="meetingSummary" rows="3" max-rows="20" maxlength="500" :state="errors.length > 0 ? false:null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getClientVisitList: {type: Function},
    },
    data() {
      return {
        id: 0,
        date: null,
        meetingPurposeSelect: 0,
        meetingPurposeOption: [],        
        employeeSelect: 0,
        employeeOption: [],
        clientResponsibleSelect: 0,
        clientResponsibleOption: [],
        meetingSummary: '',
        clientId: 0
      }
    },
    methods: {
      showInfo(id, clientId) {  
        this.$refs['clientVisitFormModal'].show()
        this.id = id
        this.clientId = clientId

        const data = {id: this.id,clientId:clientId}
        const controller = {name : 'ClientMeetingPurpose'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.date = response.data.clientMeetingPurpose.date
                this.meetingPurposeSelect = response.data.clientMeetingPurpose.meetingPurposeId
                this.meetingPurposeOption = response.data.meetingPurposeList
                this.employeeSelect = response.data.clientMeetingPurpose.employeeId
                this.employeeOption = response.data.employeeList
                this.clientResponsibleSelect = response.data.clientMeetingPurpose.clientResponsibleId
                this.clientResponsibleOption = response.data.clientResponsibleList
                this.meetingSummary = response.data.clientMeetingPurpose.meetingSummary

                
                this.clientResponsibleOption.splice(0, 0, this.$nullSelected())
                this.employeeOption.splice(0, 0, this.$nullSelected())
                this.meetingPurposeOption.splice(0, 0, this.$nullSelected())
            } else {
                this.$bvModal.hide('clientVisitFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, date: this.date, clientId: this.clientId, meetingPurposeId: this.meetingPurposeSelect, employeeId: this.employeeSelect, clientResponsibleId: this.clientResponsibleSelect,
        meetingSummary: this.meetingSummary}
        const controller = {name : 'ClientMeetingPurpose'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
           if (success) {
              this.$store.dispatch('moduleAuth/save',payload).then((response) => {
               if(response.data.resultStatus == true){
                 this.$bvModal.hide('clientVisitFormModal')
                 this.getClientVisitList()
                 this.$SaveAlert()
            } else {
              this.$WarningAlert(response.data.resultMessage)
            }
          })
            }
        })
      }
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  